import { render, staticRenderFns } from "./StockRegisterPage2.vue?vue&type=template&id=50db9b7c&scoped=true&"
import script from "./StockRegisterPage2.vue?vue&type=script&lang=js&"
export * from "./StockRegisterPage2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50db9b7c",
  null
  
)

export default component.exports